// extracted by mini-css-extract-plugin
export default {"updateModal":"rcSRpH2cp0bVIOaEJr5R","updateModalContent":"C2H9YkW4qQpcE6twc7FR","message":"drta0cC3TMIZPTQ7AbJA","button":"NFtuoyYYS94wB3lRK327"};